import { z } from 'zod';

export const CreateDepositRequestResultSchema = z.object({
  id: z.string(),
  status: z.string(),
  account_id: z.string(),
  bank_account_id: z.string(),
  payment_network: z.string(),
  currency: z.string(),
  amount: z.number(),
});

export type CreateDepositRequestResult = z.infer<
  typeof CreateDepositRequestResultSchema
>;

export interface CreateDepositRequestParams {
  bank_account_id: string;
  payment_network: string;
  currency: string;
  amount: number;
}
